export default function instituteListToMap(institutesList) {
    let intituteMap = new Map();
    institutesList.forEach((institute) => {
        intituteMap.set(institute.id, institute);
    });
    return intituteMap;
};